type Props = {
  refID?: string | number
}

export const SharedDataID: React.FC<Props> = ({ refID }) => {
  // return `IBU-${(refID??"").padStart("0", 6)}`
  return <>{refID}</>
}
